import {useQuery} from "@tanstack/react-query";
import apiClient from "../../services/apiClient";

const useFetchWhatsAppNumbers = () => useQuery({
    queryKey: ['whats-app-numbers'],
    queryFn: async () =>
        apiClient
            .get('/page/6')
            .then(res => res.data)
    ,
});

export default useFetchWhatsAppNumbers;

